import { writable, get } from "svelte/store";
import { tick } from "svelte";



const store = writable({
	route: null,
	params: null,
	queries: null,
	path: "",
	hash: "",
});
let _routes = [];
let _bootTime = 0;
let _siteName = "";
let _scrollY = 0;
let _GA4Connected = false


function getLocation() {
	let path = window.location.pathname;
	let hash = window.location.hash ? window.location.hash.substr(1) : "";

	let queries = {};
	if (window.location.search) {
		window.location.search
			.slice(1)
			.split("&")
			.forEach((s) => {
				let [key, val] = s.split("=");
				queries[key] = decodeURI(val);
			});
	}

	let dirs = path.replace(/^\//, "").replace(/\/$/, "").split("/");
	let route = {};
	let params = {};

	for (let i = 0; i < _routes.length; i++) {
		if(_routes[i].path === '*'){
			route = {..._routes[i]};
			break;
		}
		let rDirs = _routes[i].path.replace(/^\//, "").split("/");
		if (dirs.length === rDirs.length) {
			let _params = {};
			for (let j = 0; j < dirs.length; j++) {
				if (rDirs[j].substr(0, 1) === ":") {
					_params[rDirs[j].substr(1)] = dirs[j];
				} else if (rDirs[j] !== dirs[j]) {
					_params = null;
					break;
				}
			}
			if (_params) {
				params = _params;
				route = { ..._routes[i] };
				break;
			}
		}
	}
	store.set({ route, params, path, queries, hash });
}

window.addEventListener("popstate", function (e) {

	getLocation();
	if(_scrollY){
		setTimeout(() => {
			window.scrollTo( 0,_scrollY);
		},100)
	}
});

let _GA4Id = "";
let _GAId = "";
function init(routes,siteName,GA4Id, GAId) {
	_routes = routes;
	_bootTime = Date.now();
	_siteName = siteName;
	_GA4Id = GA4Id;
	_GAId = GAId;
	getLocation();
}

async function push(path,isSilent = false) {
	if (path.substr(0, 4) === "http") {
		window.open(path);
		return;
	}
	if (!path || path.substr(0, 1) !== "/") {
		throw Error("Invalid Path : " + path);
	}
	if (get(store).path === path) {
		console.warn("Same Path : ", path);
		return;
	}

	_scrollY = window.pageYOffset;
	await tick();
	window.history.pushState(null, null, path);
	if(!isSilent){
		getLocation();
	}
}

async function pop() {
	await tick();
	window.history.back();
}

async function replace(path,isSilent = false) {
	if (!path || path.length < 1 || path.charAt(0) !== "/") {
		throw Error("Invalid Path : " + path);
	}
	if (get(store).path === path && !isSilent) {
		console.warn("Same Path : ", path);
		return;
	}
	await tick();
	window.history.replaceState(null, null, path);
	if(!isSilent){
		getLocation();
	}
}

function serialize(obj) {
	const str = Object.keys(obj).map(p => {
		return p + "=" + encodeURIComponent(obj[p]);
	})
	return str.join("&");
}


function track(title){
	if(title === undefined){
		title = get(store).route.title
	}
	title = title + (title ?  "｜" : "" ) + _siteName
	document.title = title;
	if (window.gtag) {
		if(_GAId){
			window.gtag("config", _GAId,{"page_path":get(store).path});
		}
		if(_GA4Id && !_GA4Connected){
			_GA4Connected = true;
			window.gtag("config", _GA4Id);
		};
	}
}





export default {
	subscribe: store.subscribe,
	init,
	push,
	pop,
	replace,
	track,
	serialize,
	get bootTime(){
		return _bootTime
	},
	get state() {
		return get(store)
	}
};
